export const NoSoundIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_16583_10636)">
          <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="0.7" />
          <path
            d="M13.0106 9.00991L8.79999 12V6.57966C8.79999 5.07053 8.79999 4.31597 9.28371 4.06848C9.76743 3.821 10.385 4.25958 11.6202 5.13674L13.0106 6.12408C13.9369 6.78185 14.4 7.11073 14.4 7.56699C14.4 8.02325 13.9369 8.35214 13.0106 9.00991Z"
            stroke={fill}
            strokeWidth="0.7"
          />
          <path
            d="M13.0106 17.8759L11.6202 18.8633C10.385 19.7404 9.76743 20.179 9.28371 19.9315C8.79999 19.684 8.79999 18.9295 8.79999 17.4203V12L13.0106 14.9901C13.9369 15.6479 14.4 15.9767 14.4 16.433C14.4 16.8893 13.9369 17.2182 13.0106 17.8759Z"
            stroke={fill}
            strokeWidth="0.7"
          />
          <path
            d="M4.59928 14.5133C4.44092 14.6241 4.40241 14.8424 4.51326 15.0007C4.62411 15.1591 4.84234 15.1976 5.0007 15.0867L4.79999 14.8L4.59928 14.5133ZM4.79999 14.8L5.0007 15.0867L9.0007 12.2867L8.79999 12L8.59928 11.7133L4.59928 14.5133L4.79999 14.8Z"
            fill={fill}
          />
          <path
            d="M4.59928 9.48673C4.44092 9.37588 4.40241 9.15765 4.51326 8.99929C4.62411 8.84093 4.84234 8.80242 5.0007 8.91327L4.79999 9.2L4.59928 9.48673ZM4.79999 9.2L5.0007 8.91327L9.0007 11.7133L8.79999 12L8.59928 12.2867L4.59928 9.48673L4.79999 9.2Z"
            fill={fill}
          />
          <path
            d="M17.6 6.39999C17.6 6.39999 19.2 8.07999 19.2 12C19.2 15.92 17.6 17.6 17.6 17.6"
            stroke={fill}
            strokeWidth="0.7"
            strokeLinecap="round"
          />
          <path
            d="M16 8.8C16 8.8 16.8 10.32 16.8 12C16.8 13.68 16 15.2 16 15.2"
            stroke={fill}
            strokeWidth="0.7"
            strokeLinecap="round"
          />
          <path
            d="M18.5 5.5L5.50002 18.4998"
            stroke="black"
            strokeWidth="0.7"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_16583_10636">
            <rect width="24" height="24" rx="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
